import { isValidProductMediaLaunch3dDetail } from './product-media-3d-launch-analytics.js';

export const PRODUCT_MEDIA_3D_VIEWER_LOADED_EVENT = 'product-media:3d-viewer-loaded';

export const PRODUCT_MEDIA_3D_VIEWER_LOAD_FAILED_EVENT = 'product-media:3d-viewer-load-failed';

export const PRODUCT_MEDIA_3D_MODEL_INTERACTED_EVENT = 'product-media:3d-model-interacted';

export const GALLERY_HERO_3D_MODEL_CLASS_NAMES = {
	mount: 'product-media-gallery__hero-3d-model',
	mountError: 'product-media-gallery__hero-3d-model product-media-gallery__hero-3d-model--error',
};

export const GALLERY_HERO_3D_MODEL_ERROR_CLASS_NAMES = {
	container: 'product-media-gallery__hero-3d-error',
	icon: 'product-media-gallery__hero-3d-error-icon',
	message: 'product-media-gallery__hero-3d-error-message',
};

export const PRODUCT_IMAGES_3D_MODEL_CLASS_NAMES = {
	mount: 'product-3d-model__viewer-mount',
	mountError: 'product-3d-model__viewer-mount product-3d-model__viewer--error',
};

export const PRODUCT_IMAGES_3D_MODEL_ERROR_CLASS_NAMES = {
	container: 'product-3d-model__error',
	icon: 'product-3d-model__error-icon',
	message: 'product-3d-model__error-message',
};

const MODEL_VIEWER_TRANSLATION_KEYS = {
	loadingModel: 'loadingModel',
	modelViewerAlt: 'modelViewerAlt',
	unableToLoadModel: 'unableToLoadModel',
};

/**
 * @param {Record<string, string | undefined> | null | undefined} labels
 * @param {string} key
 * @returns {string}
 */
export function modelViewerTranslate(labels, key) {
	const labelKey = MODEL_VIEWER_TRANSLATION_KEYS[key];
	if (labelKey !== undefined && typeof labels?.[labelKey] === 'string' && labels[labelKey] !== '') {
		return labels[labelKey];
	}

	return key;
}

/**
 * @param {unknown} detail
 * @returns {detail is { modelUrl: string, mediaType: string }}
 */
export function isValidProductMedia3dMetricDetail(detail) {
	return isValidProductMediaLaunch3dDetail(detail);
}

/**
 * @param {unknown} detail
 */
function dispatchProductMedia3dMetric(eventName, detail) {
	if (!isValidProductMedia3dMetricDetail(detail)) {
		return;
	}

	document.dispatchEvent(new CustomEvent(eventName, { detail }));
}

/**
 * @param {unknown} detail
 */
export function dispatchProductMedia3dViewerLoaded(detail) {
	dispatchProductMedia3dMetric(PRODUCT_MEDIA_3D_VIEWER_LOADED_EVENT, detail);
}

/**
 * @param {unknown} detail
 */
export function dispatchProductMedia3dViewerLoadFailed(detail) {
	dispatchProductMedia3dMetric(PRODUCT_MEDIA_3D_VIEWER_LOAD_FAILED_EVENT, detail);
}

/**
 * @param {unknown} detail
 */
export function dispatchProductMedia3dModelInteracted(detail) {
	dispatchProductMedia3dMetric(PRODUCT_MEDIA_3D_MODEL_INTERACTED_EVENT, detail);
}
